import { ChatBot } from "./chatbot";
import { IACall } from "./ia-call";

export class InitIAButtons {
  constructor(private cahtBot: ChatBot, private iaCall: IACall) {
    this.checkConnection();
    // this.cahtBot.initChatBot();
  }

  checkConnection() {
    const url = "https://automation.maguitech.com/webhook/healthcheck";

    try {
      fetch(url)
        .then((response) => {
          if (response.ok) {
            console.log("Conexión exitosa con", url);
            this.cahtBot.initChatBot();
            this.iaCall.initCall();
          } else {
            console.error("Error en la conexión con", url);
            // this.dissableIAButtons();
          }
        })
        .catch((error) => {
          console.error("No se pudo establecer conexión con", url, error);
          this.dissableIAButtons();
        });
      } catch (error) {
        console.error("Error al verificar la conexión:", error);
        this.dissableIAButtons();
    }
  }

  dissableIAButtons() {
    const targetChat = document.querySelector("#n8n-chat");
    const buttonChat = document.querySelector(".chatbot") as HTMLElement;
    const buttonCall = document.querySelector(".ai-call") as HTMLElement;
    const buttonsContainer = document.querySelector(
      ".other-contact-methods"
    ) as HTMLElement;

    if (targetChat) {
      targetChat.remove();
      buttonChat.remove();
      buttonCall.remove();
      buttonsContainer.remove();
    }
  }
}
